import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useCallback, useRef } from 'react';
import { Dialog } from '../kit';
const useDialog = ({ title, variant }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isApplying, setIsApplying] = useState(false);
    const contentRef = useRef(null);
    const buttonsRef = useRef(undefined);
    const open = useCallback((value, buttons) => {
        contentRef.current = value;
        buttonsRef.current = buttons;
        setIsDialogOpen(true);
    }, []);
    const close = useCallback(() => {
        contentRef.current = null;
        buttonsRef.current = undefined;
        setIsDialogOpen(false);
    }, []);
    const Render = () => {
        return isDialogOpen ? (_jsx(Dialog, { title: title, variant: variant, buttons: buttonsRef.current, isButtonsDisabled: isApplying, onClose: close, children: contentRef.current })) : (_jsx(_Fragment, {}));
    };
    return { open, close, isApplying, setIsApplying, Render };
};
export { useDialog };
//# sourceMappingURL=useDialog.js.map